import React from 'react';

import { Seo, VacancyPage } from 'components';
import vacancies from 'data/vacancies';

const SITE_URL = 'https://www.nimax.ru';

const buildSchema = (v, pageUrl) => [
  {
    '@context': 'https://schema.org',
    '@type': 'JobPosting',
    title: v.title,
    description: [v.intro.lead, v.intro.text, v.requirements.lead]
      .filter(Boolean)
      .map((p) => `<p>${p}</p>`)
      .join(''),
    datePosted: v.datePosted,
    employmentType: 'FULL_TIME',
    hiringOrganization: { '@type': 'Organization', '@id': `${SITE_URL}/#organization`, name: 'Nimax', sameAs: SITE_URL },
    jobLocation: {
      '@type': 'Place',
      address: { '@type': 'PostalAddress', addressLocality: v.city, addressCountry: 'RU' }
    },
    ...(v.remote
      ? { jobLocationType: 'TELECOMMUTE', applicantLocationRequirements: { '@type': 'Country', name: 'Россия' } }
      : {}),
    ...(v.salaryFrom
      ? {
          baseSalary: {
            '@type': 'MonetaryAmount',
            currency: 'RUB',
            value: { '@type': 'QuantitativeValue', minValue: v.salaryFrom, unitText: 'MONTH' }
          }
        }
      : {}),
    ...(v.experienceYears
      ? {
          experienceRequirements: {
            '@type': 'OccupationalExperienceRequirements',
            monthsOfExperience: v.experienceYears * 12
          }
        }
      : {}),
    url: pageUrl
  },
  {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Главная', item: `${SITE_URL}/` },
      { '@type': 'ListItem', position: 2, name: 'Вакансии', item: `${SITE_URL}/jobs/` },
      { '@type': 'ListItem', position: 3, name: v.title, item: pageUrl }
    ]
  }
];

/**
 * /jobs/<slug>/ — страница вакансии
 */
export default ({ pageContext: { slug } }) => {
  const vacancy = vacancies.find((v) => v.slug === slug);
  const pageUrl = `${SITE_URL}/jobs/${slug}/`;

  return (
    <>
      <Seo
        title={vacancy.seo.title}
        description={vacancy.seo.description}
        og={vacancy.cover}
        url={pageUrl}
        schema={buildSchema(vacancy, pageUrl)}
      />
      <VacancyPage vacancy={vacancy} />
    </>
  );
};
